<script>
  export let displayTimeString;
  export let starttimeMinutes;
  export let durationMinutes;

  const offsetMinutes = starttimeMinutes - 8 * 60;

  let timeblockStyle = "position: absolute; top: " + offsetMinutes * 3 + "px; height: " + durationMinutes * 3 + "px;";
</script>

<div class="right-[2%] w-[46%] border border-solid border-gray-400/50 bg-im-brown-100/70 p-4 drop-shadow-md lg:p-1" style={timeblockStyle}>
  <p class="flex items-center gap-1 text-xs font-bold">
    <svg class="svg-inline--fa fa-sm" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
      ><path
        d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
      ></path></svg
    ><span>{displayTimeString}</span>
  </p>
  <h3 class="text-sm font-bold uppercase text-gray-700">Mittagspause</h3>
  <p class="px-2 py-1 text-xs tracking-widest">Gesetztes Mittagessen</p>
</div>
